// extracted by mini-css-extract-plugin
module.exports = {"footer":"NcoFooter_footer__38j9N"};